import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UserSettingModel } from '../../../../models/informate';

@Component({
    selector: 'app-calculation-preferences-other',
    templateUrl: './calculation-preferences-other.component.html',
    styleUrls: ['./calculation-preferences-other.component.scss'],
})
export class CalculationPreferencesOtherComponent implements OnChanges, OnInit {
    @Input() form: UntypedFormGroup;

    @Input()
    set dataSource(value: UserSettingModel[]) {
        this._dataSource = value;
    }
    get dataSource(): UserSettingModel[] {
        return this._dataSource;
    }
    private _dataSource: UserSettingModel[];

    constructor() {}

    ngOnInit(): void {
        if (!this.dataSource.length) return;

        this.initialise();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.dataSource.firstChange) return;

        this.initialise();
    }

    initialise(): void {
        //console.log('###--> CalculationPreferencesOther.component', this.dataSource, this.form)
    }
}
